import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.ends-with.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.assign.js";
import Vue from 'vue';
import { testPattern } from "../../utils/patterns.js";
import throttle from "../../utils/throttle.js";
import cache from "../../utils/cache.js";
import { stop } from "../../utils/event.js";
import { hexToRgb, rgbToHex, rgbToString, textToRgb, rgbToHsv, hsvToRgb, luminosity } from "../../utils/colors.js";
import DarkMixin from "../../mixins/dark.js";
import FormMixin from "../../mixins/form.js";
import ListenersMixin from "../../mixins/listeners.js";
import TouchPan from "../../directives/TouchPan.js";
import QSlider from "../slider/QSlider.js";
import QIcon from "../icon/QIcon.js";
import QTabs from "../tabs/QTabs.js";
import QTab from "../tabs/QTab.js";
import QTabPanels from "../tab-panels/QTabPanels.js";
import QTabPanel from "../tab-panels/QTabPanel.js";
var palette = ['rgb(255,204,204)', 'rgb(255,230,204)', 'rgb(255,255,204)', 'rgb(204,255,204)', 'rgb(204,255,230)', 'rgb(204,255,255)', 'rgb(204,230,255)', 'rgb(204,204,255)', 'rgb(230,204,255)', 'rgb(255,204,255)', 'rgb(255,153,153)', 'rgb(255,204,153)', 'rgb(255,255,153)', 'rgb(153,255,153)', 'rgb(153,255,204)', 'rgb(153,255,255)', 'rgb(153,204,255)', 'rgb(153,153,255)', 'rgb(204,153,255)', 'rgb(255,153,255)', 'rgb(255,102,102)', 'rgb(255,179,102)', 'rgb(255,255,102)', 'rgb(102,255,102)', 'rgb(102,255,179)', 'rgb(102,255,255)', 'rgb(102,179,255)', 'rgb(102,102,255)', 'rgb(179,102,255)', 'rgb(255,102,255)', 'rgb(255,51,51)', 'rgb(255,153,51)', 'rgb(255,255,51)', 'rgb(51,255,51)', 'rgb(51,255,153)', 'rgb(51,255,255)', 'rgb(51,153,255)', 'rgb(51,51,255)', 'rgb(153,51,255)', 'rgb(255,51,255)', 'rgb(255,0,0)', 'rgb(255,128,0)', 'rgb(255,255,0)', 'rgb(0,255,0)', 'rgb(0,255,128)', 'rgb(0,255,255)', 'rgb(0,128,255)', 'rgb(0,0,255)', 'rgb(128,0,255)', 'rgb(255,0,255)', 'rgb(245,0,0)', 'rgb(245,123,0)', 'rgb(245,245,0)', 'rgb(0,245,0)', 'rgb(0,245,123)', 'rgb(0,245,245)', 'rgb(0,123,245)', 'rgb(0,0,245)', 'rgb(123,0,245)', 'rgb(245,0,245)', 'rgb(214,0,0)', 'rgb(214,108,0)', 'rgb(214,214,0)', 'rgb(0,214,0)', 'rgb(0,214,108)', 'rgb(0,214,214)', 'rgb(0,108,214)', 'rgb(0,0,214)', 'rgb(108,0,214)', 'rgb(214,0,214)', 'rgb(163,0,0)', 'rgb(163,82,0)', 'rgb(163,163,0)', 'rgb(0,163,0)', 'rgb(0,163,82)', 'rgb(0,163,163)', 'rgb(0,82,163)', 'rgb(0,0,163)', 'rgb(82,0,163)', 'rgb(163,0,163)', 'rgb(92,0,0)', 'rgb(92,46,0)', 'rgb(92,92,0)', 'rgb(0,92,0)', 'rgb(0,92,46)', 'rgb(0,92,92)', 'rgb(0,46,92)', 'rgb(0,0,92)', 'rgb(46,0,92)', 'rgb(92,0,92)', 'rgb(255,255,255)', 'rgb(205,205,205)', 'rgb(178,178,178)', 'rgb(153,153,153)', 'rgb(127,127,127)', 'rgb(102,102,102)', 'rgb(76,76,76)', 'rgb(51,51,51)', 'rgb(25,25,25)', 'rgb(0,0,0)'];
var thumbPath = 'M5 5 h10 v10 h-10 v-10 z';
var alphaTrackImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAH0lEQVQoU2NkYGAwZkAFZ5G5jPRRgOYEVDeB3EBjBQBOZwTVugIGyAAAAABJRU5ErkJggg==';
export default Vue.extend({
  name: 'QColor',
  mixins: [ListenersMixin, DarkMixin, FormMixin],
  directives: {
    TouchPan: TouchPan
  },
  props: {
    value: String,
    defaultValue: String,
    defaultView: {
      type: String,
      default: 'spectrum',
      validator: function validator(v) {
        return ['spectrum', 'tune', 'palette'].includes(v);
      }
    },
    formatModel: {
      type: String,
      default: 'auto',
      validator: function validator(v) {
        return ['auto', 'hex', 'rgb', 'hexa', 'rgba'].includes(v);
      }
    },
    palette: Array,
    noHeader: Boolean,
    noHeaderTabs: Boolean,
    noFooter: Boolean,
    square: Boolean,
    flat: Boolean,
    bordered: Boolean,
    disable: Boolean,
    readonly: Boolean
  },
  data: function data() {
    return {
      topView: this.formatModel === 'auto' ? this.value === void 0 || this.value === null || this.value === '' || this.value.startsWith('#') ? 'hex' : 'rgb' : this.formatModel.startsWith('hex') ? 'hex' : 'rgb',
      view: this.defaultView,
      model: this.__parseModel(this.value || this.defaultValue)
    };
  },
  watch: {
    value: function value(v) {
      var model = this.__parseModel(v || this.defaultValue);

      if (model.hex !== this.model.hex) {
        this.model = model;
      }
    },
    defaultValue: function defaultValue(v) {
      if (!this.value && v) {
        var model = this.__parseModel(v);

        if (model.hex !== this.model.hex) {
          this.model = model;
        }
      }
    }
  },
  computed: {
    editable: function editable() {
      return this.disable !== true && this.readonly !== true;
    },
    forceHex: function forceHex() {
      return this.formatModel === 'auto' ? null : this.formatModel.indexOf('hex') > -1;
    },
    forceAlpha: function forceAlpha() {
      return this.formatModel === 'auto' ? null : this.formatModel.indexOf('a') > -1;
    },
    isHex: function isHex() {
      return this.value === void 0 || this.value === null || this.value === '' || this.value.startsWith('#');
    },
    isOutputHex: function isOutputHex() {
      return this.forceHex !== null ? this.forceHex : this.isHex;
    },
    formAttrs: function formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: this.model[this.isOutputHex === true ? 'hex' : 'rgb']
      };
    },
    hasAlpha: function hasAlpha() {
      if (this.forceAlpha !== null) {
        return this.forceAlpha;
      }

      return this.model.a !== void 0;
    },
    currentBgColor: function currentBgColor() {
      return {
        backgroundColor: this.model.rgb || '#000'
      };
    },
    headerClass: function headerClass() {
      var light = this.model.a !== void 0 && this.model.a < 65 ? true : luminosity(this.model) > 0.4;
      return "q-color-picker__header-content--".concat(light ? 'light' : 'dark');
    },
    spectrumStyle: function spectrumStyle() {
      return {
        background: "hsl(".concat(this.model.h, ",100%,50%)")
      };
    },
    spectrumPointerStyle: function spectrumPointerStyle() {
      return _defineProperty({
        top: "".concat(100 - this.model.v, "%")
      }, this.$q.lang.rtl === true ? 'right' : 'left', "".concat(this.model.s, "%"));
    },
    computedPalette: function computedPalette() {
      return this.palette !== void 0 && this.palette.length > 0 ? this.palette : palette;
    },
    classes: function classes() {
      return 'q-color-picker' + (this.bordered === true ? ' q-color-picker--bordered' : '') + (this.square === true ? ' q-color-picker--square no-border-radius' : '') + (this.flat === true ? ' q-color-picker--flat no-shadow' : '') + (this.disable === true ? ' disabled' : '') + (this.isDark === true ? ' q-color-picker--dark q-dark' : '');
    },
    attrs: function attrs() {
      if (this.disable === true) {
        return {
          'aria-disabled': 'true'
        };
      }

      if (this.readonly === true) {
        return {
          'aria-readonly': 'true'
        };
      }
    }
  },
  created: function created() {
    this.__spectrumChange = throttle(this.__spectrumChange, 20);
  },
  render: function render(h) {
    var child = [this.__getContent(h)];

    if (this.name !== void 0 && this.disable !== true) {
      this.__injectFormInput(child, 'push');
    }

    this.noHeader !== true && child.unshift(this.__getHeader(h));
    this.noFooter !== true && child.push(this.__getFooter(h));
    return h('div', {
      class: this.classes,
      attrs: this.attrs,
      on: _objectSpread({}, this.qListeners)
    }, child);
  },
  methods: {
    __getHeader: function __getHeader(h) {
      var _this = this;

      var child = [];
      this.noHeaderTabs !== true && child.push(h(QTabs, {
        class: 'q-color-picker__header-tabs',
        props: {
          value: this.topView,
          dense: true,
          align: 'justify'
        },
        on: cache(this, 'topVTab', {
          input: function input(val) {
            _this.topView = val;
          }
        })
      }, [h(QTab, {
        props: {
          label: 'HEX' + (this.hasAlpha === true ? 'A' : ''),
          name: 'hex',
          ripple: false
        }
      }), h(QTab, {
        props: {
          label: 'RGB' + (this.hasAlpha === true ? 'A' : ''),
          name: 'rgb',
          ripple: false
        }
      })]));
      child.push(h('div', {
        staticClass: 'q-color-picker__header-banner row flex-center no-wrap'
      }, [h('input', {
        staticClass: 'fit',
        domProps: {
          value: this.model[this.topView]
        },
        attrs: this.editable !== true ? {
          readonly: true
        } : null,
        on: cache(this, 'topIn', {
          input: function input(evt) {
            _this.__updateErrorIcon(_this.__onEditorChange(evt) === true);
          },
          change: stop,
          blur: function blur(evt) {
            _this.__onEditorChange(evt, true) === true && _this.$forceUpdate();

            _this.__updateErrorIcon(false);
          }
        })
      }), h(QIcon, {
        ref: 'errorIcon',
        staticClass: 'q-color-picker__error-icon absolute no-pointer-events',
        props: {
          name: this.$q.iconSet.type.negative
        }
      })]));
      return h('div', {
        staticClass: 'q-color-picker__header relative-position overflow-hidden'
      }, [h('div', {
        staticClass: 'q-color-picker__header-bg absolute-full'
      }), h('div', {
        staticClass: 'q-color-picker__header-content',
        class: this.headerClass,
        style: this.currentBgColor
      }, child)]);
    },
    __getContent: function __getContent(h) {
      return h(QTabPanels, {
        props: {
          value: this.view,
          animated: true
        }
      }, [h(QTabPanel, {
        staticClass: 'q-color-picker__spectrum-tab overflow-hidden',
        props: {
          name: 'spectrum'
        }
      }, this.__getSpectrumTab(h)), h(QTabPanel, {
        staticClass: 'q-pa-md q-color-picker__tune-tab',
        props: {
          name: 'tune'
        }
      }, this.__getTuneTab(h)), h(QTabPanel, {
        staticClass: 'q-color-picker__palette-tab',
        props: {
          name: 'palette'
        }
      }, this.__getPaletteTab(h))]);
    },
    __getFooter: function __getFooter(h) {
      var _this2 = this;

      return h('div', {
        staticClass: 'q-color-picker__footer relative-position overflow-hidden'
      }, [h(QTabs, {
        staticClass: 'absolute-full',
        props: {
          value: this.view,
          dense: true,
          align: 'justify'
        },
        on: cache(this, 'ftIn', {
          input: function input(val) {
            _this2.view = val;
          }
        })
      }, [h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.spectrum,
          name: 'spectrum',
          ripple: false
        }
      }), h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.tune,
          name: 'tune',
          ripple: false
        }
      }), h(QTab, {
        props: {
          icon: this.$q.iconSet.colorPicker.palette,
          name: 'palette',
          ripple: false
        }
      })])]);
    },
    __getSpectrumTab: function __getSpectrumTab(h) {
      var _this3 = this;

      return [h('div', {
        ref: 'spectrum',
        staticClass: 'q-color-picker__spectrum non-selectable relative-position cursor-pointer',
        style: this.spectrumStyle,
        class: {
          readonly: this.editable !== true
        },
        on: this.editable === true ? cache(this, 'spectrT', {
          click: this.__spectrumClick,
          mousedown: this.__activate
        }) : null,
        directives: this.editable === true ? cache(this, 'spectrDir', [{
          name: 'touch-pan',
          modifiers: {
            prevent: true,
            stop: true,
            mouse: true
          },
          value: this.__spectrumPan
        }]) : null
      }, [h('div', {
        style: {
          paddingBottom: '100%'
        }
      }), h('div', {
        staticClass: 'q-color-picker__spectrum-white absolute-full'
      }), h('div', {
        staticClass: 'q-color-picker__spectrum-black absolute-full'
      }), h('div', {
        staticClass: 'absolute',
        style: this.spectrumPointerStyle
      }, [this.model.hex !== void 0 ? h('div', {
        staticClass: 'q-color-picker__spectrum-circle'
      }) : null])]), h('div', {
        staticClass: 'q-color-picker__sliders'
      }, [h(QSlider, {
        staticClass: 'q-color-picker__hue non-selectable',
        props: {
          value: this.model.h,
          min: 0,
          max: 360,
          trackSize: '8px',
          innerTrackColor: 'transparent',
          selectionColor: 'transparent',
          readonly: this.editable !== true,
          thumbPath: thumbPath
        },
        on: cache(this, 'hueSlide', {
          input: this.__onHueChange,
          change: function change(val) {
            return _this3.__onHueChange(val, true);
          }
        })
      }), this.hasAlpha === true ? h(QSlider, {
        staticClass: 'q-color-picker__alpha non-selectable',
        props: {
          value: this.model.a,
          min: 0,
          max: 100,
          trackSize: '8px',
          trackColor: 'white',
          innerTrackColor: 'transparent',
          selectionColor: 'transparent',
          trackImg: alphaTrackImg,
          readonly: this.editable !== true,
          hideSelection: true,
          thumbPath: thumbPath
        },
        on: cache(this, 'alphaSlide', {
          input: function input(value) {
            return _this3.__onNumericChange(value, 'a', 100);
          },
          change: function change(value) {
            return _this3.__onNumericChange(value, 'a', 100, void 0, true);
          }
        })
      }) : null])];
    },
    __getTuneTab: function __getTuneTab(h) {
      var _this4 = this;

      var attrs = {
        inputmode: 'numeric',
        maxlength: 3,
        readonly: this.editable !== true
      };
      return [h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['R']), h(QSlider, {
        props: {
          value: this.model.r,
          min: 0,
          max: 255,
          color: 'red',
          dark: this.isDark,
          readonly: this.editable !== true
        },
        on: cache(this, 'rSlide', {
          input: function input(value) {
            return _this4.__onNumericChange(value, 'r', 255);
          },
          change: function change(value) {
            return _this4.__onNumericChange(value, 'r', 255, void 0, true);
          }
        })
      }), h('input', {
        domProps: {
          value: this.model.r
        },
        attrs: attrs,
        on: cache(this, 'rIn', {
          input: function input(evt) {
            return _this4.__onNumericChange(evt.target.value, 'r', 255, evt);
          },
          change: stop,
          blur: function blur(evt) {
            return _this4.__onNumericChange(evt.target.value, 'r', 255, evt, true);
          }
        })
      })]), h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['G']), h(QSlider, {
        props: {
          value: this.model.g,
          min: 0,
          max: 255,
          color: 'green',
          dark: this.isDark,
          readonly: this.editable !== true
        },
        on: cache(this, 'gSlide', {
          input: function input(value) {
            return _this4.__onNumericChange(value, 'g', 255);
          },
          change: function change(value) {
            return _this4.__onNumericChange(value, 'g', 255, void 0, true);
          }
        })
      }), h('input', {
        domProps: {
          value: this.model.g
        },
        attrs: attrs,
        on: cache(this, 'gIn', {
          input: function input(evt) {
            return _this4.__onNumericChange(evt.target.value, 'g', 255, evt);
          },
          change: stop,
          blur: function blur(evt) {
            return _this4.__onNumericChange(evt.target.value, 'g', 255, evt, true);
          }
        })
      })]), h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['B']), h(QSlider, {
        props: {
          value: this.model.b,
          min: 0,
          max: 255,
          color: 'blue',
          readonly: this.editable !== true,
          dark: this.isDark
        },
        on: cache(this, 'bSlide', {
          input: function input(value) {
            return _this4.__onNumericChange(value, 'b', 255);
          },
          change: function change(value) {
            return _this4.__onNumericChange(value, 'b', 255, void 0, true);
          }
        })
      }), h('input', {
        domProps: {
          value: this.model.b
        },
        attrs: attrs,
        on: cache(this, 'bIn', {
          input: function input(evt) {
            return _this4.__onNumericChange(evt.target.value, 'b', 255, evt);
          },
          change: stop,
          blur: function blur(evt) {
            return _this4.__onNumericChange(evt.target.value, 'b', 255, evt, true);
          }
        })
      })]), this.hasAlpha === true ? h('div', {
        staticClass: 'row items-center no-wrap'
      }, [h('div', ['A']), h(QSlider, {
        props: {
          value: this.model.a,
          color: 'grey',
          readonly: this.editable !== true,
          dark: this.isDark
        },
        on: cache(this, 'aSlide', {
          input: function input(value) {
            return _this4.__onNumericChange(value, 'a', 100);
          },
          change: function change(value) {
            return _this4.__onNumericChange(value, 'a', 100, void 0, true);
          }
        })
      }), h('input', {
        domProps: {
          value: this.model.a
        },
        attrs: attrs,
        on: cache(this, 'aIn', {
          input: function input(evt) {
            return _this4.__onNumericChange(evt.target.value, 'a', 100, evt);
          },
          change: stop,
          blur: function blur(evt) {
            return _this4.__onNumericChange(evt.target.value, 'a', 100, evt, true);
          }
        })
      })]) : null];
    },
    __getPaletteTab: function __getPaletteTab(h) {
      var _this5 = this;

      return [h('div', {
        staticClass: 'row items-center q-color-picker__palette-rows',
        class: this.editable === true ? 'q-color-picker__palette-rows--editable' : ''
      }, this.computedPalette.map(function (color) {
        return h('div', {
          staticClass: 'q-color-picker__cube col-auto',
          style: {
            backgroundColor: color
          },
          on: _this5.editable === true ? cache(_this5, 'palette#' + color, {
            click: function click() {
              _this5.__onPalettePick(color);
            }
          }) : null
        });
      }))];
    },
    __onSpectrumChange: function __onSpectrumChange(left, top, change) {
      var panel = this.$refs.spectrum;

      if (panel === void 0) {
        return;
      }

      var width = panel.clientWidth,
          height = panel.clientHeight,
          rect = panel.getBoundingClientRect();
      var x = Math.min(width, Math.max(0, left - rect.left));

      if (this.$q.lang.rtl === true) {
        x = width - x;
      }

      var y = Math.min(height, Math.max(0, top - rect.top)),
          s = Math.round(100 * x / width),
          v = Math.round(100 * Math.max(0, Math.min(1, -(y / height) + 1))),
          rgb = hsvToRgb({
        h: this.model.h,
        s: s,
        v: v,
        a: this.hasAlpha === true ? this.model.a : void 0
      });
      this.model.s = s;
      this.model.v = v;

      this.__update(rgb, change);
    },
    __onHueChange: function __onHueChange(h, change) {
      h = Math.round(h);
      var rgb = hsvToRgb({
        h: h,
        s: this.model.s,
        v: this.model.v,
        a: this.hasAlpha === true ? this.model.a : void 0
      });
      this.model.h = h;

      this.__update(rgb, change);
    },
    __onNumericChange: function __onNumericChange(value, formatModel, max, evt, change) {
      evt !== void 0 && stop(evt);

      if (!/^[0-9]+$/.test(value)) {
        change === true && this.$forceUpdate();
        return;
      }

      var val = Math.floor(Number(value));

      if (val < 0 || val > max) {
        change === true && this.$forceUpdate();
        return;
      }

      var rgb = {
        r: formatModel === 'r' ? val : this.model.r,
        g: formatModel === 'g' ? val : this.model.g,
        b: formatModel === 'b' ? val : this.model.b,
        a: this.hasAlpha === true ? formatModel === 'a' ? val : this.model.a : void 0
      };

      if (formatModel !== 'a') {
        var hsv = rgbToHsv(rgb);
        this.model.h = hsv.h;
        this.model.s = hsv.s;
        this.model.v = hsv.v;
      }

      this.__update(rgb, change);

      if (evt !== void 0 && change !== true && evt.target.selectionEnd !== void 0) {
        var index = evt.target.selectionEnd;
        this.$nextTick(function () {
          evt.target.setSelectionRange(index, index);
        });
      }
    },
    __onEditorChange: function __onEditorChange(evt, change) {
      var rgb;
      var inp = evt.target.value;
      stop(evt);

      if (this.topView === 'hex') {
        if (inp.length !== (this.hasAlpha === true ? 9 : 7) || !/^#[0-9A-Fa-f]+$/.test(inp)) {
          return true;
        }

        rgb = hexToRgb(inp);
      } else {
        var model;

        if (!inp.endsWith(')')) {
          return true;
        } else if (this.hasAlpha !== true && inp.startsWith('rgb(')) {
          model = inp.substring(4, inp.length - 1).split(',').map(function (n) {
            return parseInt(n, 10);
          });

          if (model.length !== 3 || !/^rgb\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3}\)$/.test(inp)) {
            return true;
          }
        } else if (this.hasAlpha === true && inp.startsWith('rgba(')) {
          model = inp.substring(5, inp.length - 1).split(',');

          if (model.length !== 4 || !/^rgba\([0-9]{1,3},[0-9]{1,3},[0-9]{1,3},(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/.test(inp)) {
            return true;
          }

          for (var i = 0; i < 3; i++) {
            var _v = parseInt(model[i], 10);

            if (_v < 0 || _v > 255) {
              return true;
            }

            model[i] = _v;
          }

          var v = parseFloat(model[3]);

          if (v < 0 || v > 1) {
            return true;
          }

          model[3] = v;
        } else {
          return true;
        }

        if (model[0] < 0 || model[0] > 255 || model[1] < 0 || model[1] > 255 || model[2] < 0 || model[2] > 255 || this.hasAlpha === true && (model[3] < 0 || model[3] > 1)) {
          return true;
        }

        rgb = {
          r: model[0],
          g: model[1],
          b: model[2],
          a: this.hasAlpha === true ? model[3] * 100 : void 0
        };
      }

      var hsv = rgbToHsv(rgb);
      this.model.h = hsv.h;
      this.model.s = hsv.s;
      this.model.v = hsv.v;

      this.__update(rgb, change);

      if (change !== true) {
        var index = evt.target.selectionEnd;
        this.$nextTick(function () {
          evt.target.setSelectionRange(index, index);
        });
      }
    },
    __onPalettePick: function __onPalettePick(color) {
      var def = this.__parseModel(color);

      var rgb = {
        r: def.r,
        g: def.g,
        b: def.b,
        a: def.a
      };

      if (rgb.a === void 0) {
        rgb.a = this.model.a;
      }

      this.model.h = def.h;
      this.model.s = def.s;
      this.model.v = def.v;

      this.__update(rgb, true);
    },
    __update: function __update(rgb, change) {
      // update internally
      this.model.hex = rgbToHex(rgb);
      this.model.rgb = rgbToString(rgb);
      this.model.r = rgb.r;
      this.model.g = rgb.g;
      this.model.b = rgb.b;
      this.model.a = rgb.a;
      var value = this.model[this.isOutputHex === true ? 'hex' : 'rgb']; // emit new value

      this.$emit('input', value);
      change === true && this.$emit('change', value);
    },
    __updateErrorIcon: function __updateErrorIcon(val) {
      // we MUST avoid vue triggering a render,
      // so manually changing this
      if (this.$refs.errorIcon !== void 0) {
        this.$refs.errorIcon.$el.style.opacity = val ? 1 : 0;
      }
    },
    __parseModel: function __parseModel(v) {
      var forceAlpha = this.forceAlpha !== void 0 ? this.forceAlpha : this.formatModel === 'auto' ? null : this.formatModel.indexOf('a') > -1;

      if (typeof v !== 'string' || v.length === 0 || testPattern.anyColor(v.replace(/ /g, '')) !== true) {
        return {
          h: 0,
          s: 0,
          v: 0,
          r: 0,
          g: 0,
          b: 0,
          a: forceAlpha === true ? 100 : void 0,
          hex: void 0,
          rgb: void 0
        };
      }

      var model = textToRgb(v);

      if (forceAlpha === true && model.a === void 0) {
        model.a = 100;
      }

      model.hex = rgbToHex(model);
      model.rgb = rgbToString(model);
      return Object.assign(model, rgbToHsv(model));
    },
    __spectrumPan: function __spectrumPan(evt) {
      if (evt.isFinal) {
        this.__onSpectrumChange(evt.position.left, evt.position.top, true);
      } else {
        this.__spectrumChange(evt);
      }
    },
    // throttled in created()
    __spectrumChange: function __spectrumChange(evt) {
      this.__onSpectrumChange(evt.position.left, evt.position.top);
    },
    __spectrumClick: function __spectrumClick(evt) {
      this.__onSpectrumChange(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset, true);
    },
    __activate: function __activate(evt) {
      this.__onSpectrumChange(evt.pageX - window.pageXOffset, evt.pageY - window.pageYOffset);
    }
  }
});